import { Box } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CartMetadata } from 'src/common/interfaces/dtos/ICartMetadata';
import OrderItem from '../order-item/order-item';
import { styles } from './order-item-list-styles';

interface OrderItemListProps {
  orders: CartMetadata[];
  isPhoneNumber?: boolean;
  selectedOrder: number | string;
  onSelectOrder: () => void;
}

const OrderItemList = ({
  orders,
  isPhoneNumber,
  selectedOrder,
  onSelectOrder,
}: OrderItemListProps): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();

  const numberString = t(isPhoneNumber ? 'PendingOrderLoyalty' : 'PendingOrderPhone');

  if (orders.length === 0) {
    return (
      <Box className={classes.emptyResultsLabel}>
        <Box>{t('PendingOrderText')}</Box>
        <Box>{t('PendingOrderDetails', { arg: numberString })}</Box>
      </Box>
    );
  }
  return (
    <Box className={classes.resultsContainer}>
      {orders.map(
        (order, index): JSX.Element => {
          const isSelected = order.orderId === selectedOrder;
          return (
            <OrderItem
              key={order.orderId}
              index={index}
              order={order}
              isSelected={isSelected}
              onSelectOrder={onSelectOrder}
            />
          );
        },
      )}
    </Box>
  );
};

export default OrderItemList;
